// extracted by mini-css-extract-plugin
export default {"box":"ProductList_box__PrFJj","list":"ProductList_list__d6+57","itemBox":"ProductList_itemBox__LfgrC","title":"ProductList_title__pYdNX","btn":"ProductList_btn__Z-sA7"};